import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { fromEvent, Subject, merge, of, Subscription } from "rxjs";
import {
    catchError,
    map,
    filter,
    switchMap,
    takeUntil,
    tap,
} from "rxjs/operators";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { fuseAnimations } from "@fuse/animations";

import { ClienteDTO } from "app/main/apps/shared/interfaces/cliente.interface";

import { PageClienteDTO } from "app/main/apps/shared/interfaces/page-cliente.interface";
import { ClienteService } from "app/main/apps/shared/services/rest/cliente.service";
import { OnDestroy } from "@angular/core";

@Component({
    selector: "app-tabla-clientes",
    templateUrl: "./tabla-clientes.component.html",
    styleUrls: ["./tabla-clientes.component.scss"],
    animations: fuseAnimations,
})
export class TablaClientesComponent implements OnInit, OnDestroy {
    @Input() clientes: ClienteDTO[];
    @Input() totalRegistros: number;

    @Output() buscarMas: EventEmitter<any> = new EventEmitter();
    dataSource: MatTableDataSource<ClienteDTO>;
    displayedColumns = ["nombre", "nrrut", "fechainicio", "activo"];

    @ViewChild(MatPaginator, { static: true })
    paginator: MatPaginator;

    @ViewChild(MatSort, { static: true })
    sort: MatSort;

    @ViewChild("filter", { static: true })
    filter: ElementRef;

    resultsLength = 0;
    private subscripciones: Subscription;
    private _unsubscribeAll: Subject<any>;

    constructor(
        private _fuseProgressBarService: FuseProgressBarService,
        private _clienteSrvc: ClienteService
    ) {
        this.subscripciones = new Subscription();
        this._unsubscribeAll = new Subject();
    }
    ngOnInit(): void {
        this.resultsLength = this.clientes.length;
        this.dataSource = new MatTableDataSource(this.clientes);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.subscripciones.add(
            this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0))
        );

        /*
        fromEvent(this.filter.nativeElement, "keyup")
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(150),
                distinctUntilChanged()
            )
            .subscribe(() => {
                if (!this.dataSource) {
                    return;
                }

                this.dataSource.filter = this.filter.nativeElement.value;
            });
        */
        setTimeout(() => {
            this.tableChange();
        });
    }

    /*   
    tableChange() {
        console.log('xxx');
        this.subscripciones.add(
            merge(this.sort.sortChange, this.paginator.page)
                .pipe(
                    // startWith({}),
                    switchMap(() => {
                        this._fuseProgressBarService.show();
                        const paginacion = {
                            sort: this.sort.direction,
                            page: this.paginator.pageIndex,
                            resultados: this.paginator.pageSize,
                        };
                        this.buscarMas.emit(paginacion);
                        //return this.buscar();
                        return this._clienteSrvc.clientesChanged$;
                    }),
                    map((data: PageClienteDTO) => {
                        // Flip flag to show that loading has finished.

                        this._fuseProgressBarService.hide();

                        this.resultsLength = data.totalElements;

                        return data.content;
                    }),
                    catchError(() => {
                        this._fuseProgressBarService.hide();
                        // Catch if the GitHub API has reached its rate limit. Return empty data.

                        return of([]);
                    })
                )
                .subscribe((data: ClienteDTO[]) => {
                    console.log(data);
                    this.clientes = data;
                    this.dataSource = new MatTableDataSource(this.clientes);
                })
        );
    }
  */

    tableChange() {
        this.resultsLength = this.totalRegistros;
        merge(
            this.sort.sortChange.pipe(
                tap((data) => console.log("refreh sort"))
            ),
            this.paginator.page.pipe(
                tap((data) => console.log("refreh paginator"))
            ),
            this._clienteSrvc.clienteRefresh$.pipe(
                tap((data) => console.log("refresh!", data)),
                filter(
                    (refresh) => refresh //filtro para ordenesCompraRefresh$, merge se activa solo si el valor emitido es true, para evitar dobles llamadas
                )
            )
        )
            .pipe(
                // startWith({}),
                takeUntil(this._unsubscribeAll),

                switchMap((filtros) => {
                    //console.log(filtros);
                    this._fuseProgressBarService.show();
                    this._clienteSrvc.setPaginaActual(this.paginator.pageIndex);
                    this._clienteSrvc.setCantidaResultadosPorPagina(
                        this.paginator.pageSize
                    );
                    this._clienteSrvc.setCampoOrden(this.sort.active);
                    this._clienteSrvc.setOrden(this.sort.direction);

                    this.buscarMas.emit();
                    //return this.buscar();
                    return this._clienteSrvc.clientesChanged$;
                }),
                map((data: PageClienteDTO) => {
                    // Flip flag to show that loading has finished.
                    this._fuseProgressBarService.hide();
                    this.resultsLength = data.totalElements;
                    /*    this._facturaSrvc.setTotalDeResultados(
                        data.totalElements
                    );*/

                    return data.content;
                }),
                catchError(() => {
                    this._fuseProgressBarService.hide();
                    // Catch if the GitHub API has reached its rate limit. Return empty data.

                    return of([]);
                })
            )
            .subscribe((data: ClienteDTO[]) => {
                this.clientes = data;
                this.dataSource = new MatTableDataSource(this.clientes);
            });
        //);
    }

    verCliente(): void {}

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
